import { render, staticRenderFns } from "./prize-pool.vue?vue&type=template&id=4ae41a06&scoped=true"
import script from "./prize-pool.vue?vue&type=script&lang=js"
export * from "./prize-pool.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae41a06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ae41a06')) {
      api.createRecord('4ae41a06', component.options)
    } else {
      api.reload('4ae41a06', component.options)
    }
    module.hot.accept("./prize-pool.vue?vue&type=template&id=4ae41a06&scoped=true", function () {
      api.rerender('4ae41a06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/marketing/activities/prize-pool.vue"
export default component.exports